import { createActions, createReducer } from 'reduxsauce';

//creacion de acciones
const { Types, Creators } = createActions({
  setCosto: ['costo'],
});
//estado inicial
const INITIAL_STATE = {
  costo: 0,
};
//reducer
const setCosto = (state, { costo }) => ({
  ...state,
  costo,
});
//creacion del reducer
export const costoReducer = createReducer(INITIAL_STATE, {
  [Types.SET_COSTO]: setCosto,
});
//exportacion de tipos de acciones
export const CostoActions = Creators;